import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFreeAccountStatus from '../../hooks/useFreeAccountStatus';
import { dismissPromo, isPromoDismissed } from '../../utils/welcome';
import '../../styles/BusinessPromoBar.css';

function BusinessPromoBar({ onVisibilityChange }) {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => isPromoDismissed());
  const { status } = useFreeAccountStatus(!dismissed);

  const visible = !dismissed && !!status && status.remaining > 0;

  useEffect(() => {
    onVisibilityChange?.(visible);
  }, [visible, onVisibilityChange]);

  if (!visible) return null;

  return (
    <div className="biz-promo-bar" role="region" aria-label="عرض انضمام الأعمال">
      <button
        type="button"
        className="biz-promo-close"
        aria-label="إغلاق"
        onClick={() => {
          dismissPromo();
          setDismissed(true);
        }}
      >
        ×
      </button>

      <div className="biz-promo-copy">
        <p className="biz-promo-headline">
          هل تملك صالوناً؟ انضم إلى أدواري مجاناً لمدة 6 أشهر
        </p>
        <p className="biz-promo-count">
          لأول {status.total} منضم — متبقٍ <strong>{status.remaining}</strong> من أصل {status.total}
        </p>
      </div>

      <button
        type="button"
        className="biz-promo-cta"
        onClick={() => navigate('/register-business')}
      >
        انضم الآن
      </button>
    </div>
  );
}

export default BusinessPromoBar;
